/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Erfahrungstufeag21Inputs */



/**

* @param {_Field_Erfahrungstufeag21Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_erfahrungstufeag21 = /** @type {((inputs?: _Field_Erfahrungstufeag21Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Erfahrungstufeag21Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Erfahrungstufe AG 2")
});
export { _field_erfahrungstufeag21 as "_field_erfahrungstufeAg2" }